import { reactive, ref } from 'vue';

export const promotion_page = ref(1);
export const promotion_id = ref(null);
export const form_promotion_Body = reactive<any>({
  name: '',
  description: '',
  isActive: true,
  type: '',
  trigger: '',
  status: '',
  code: '',
  value: '',
  minimumOrderAmount: '',
  maximumDiscountAmount: '',
  startDate: '',
  endDate: '',
  usageLimit: '',
  usageLimitPerCustomer: '',
  priority: '',
  stackable: '',
});

export const categoryIds_product_promotion = ref<string[]>([]);
export const remove_categoryIds_product_promotion = ref<string[]>([]);
export const rules_promotion = ref<any[]>([
  {
    type: '',
    operator: '',
    value: '',
  },
]);

export const productIds_promotion = ref<string[]>([]);
export const remove_productIds_promotion = ref<string[]>([]);
export const isAtcivatedWatchPromotion = ref(false);
export const isUpdateFromPromotion = ref(false);
export const isDeletedFromPromotion = ref(false);
export const code = ref<string | null>(null);
export const trigger = ref<
  | 'automatic'
  | 'code_required'
  | 'first_time_customer'
  | 'customer_segment'
  | null
>(null);
export const statusProm = ref<
  'draft' | 'active' | 'paused' | 'expired' | 'exhausted' | null
>(null);
export const type = ref<
  | 'percentage'
  | 'fixed_amount'
  | 'buy_one_get_one'
  | 'quantity_discount'
  | 'bundle_discount'
  | null
>(null);
export const isPromoFistStep = ref(true);
export const isPromoProductStep = ref(false);
export const isPromoCategoryStep = ref(false);
export const isPromoRulesStep = ref(false);
